<template>
  <div class="checkout-btn">
    <a href="#">
      <fai icon="shopping-bag" class="icon"></fai>
      <span v-html="$t('message.booking')"></span>
      <fai icon="caret-down" class="icon"></fai>
    </a>
    <ul class="submenu" v-if="settings">
      <li v-for="(btn, i) in settings.ctas" :key="i">
        <a :style="{ backgroundColor: btn.color ? btn.color.color : '#000'}" @click.prevent="getStoryblokLink(btn.link)" :href="btn.link.cached_url">
          <fai :icon="getIcon(btn.icon)" class="icon"></fai>
          <span>{{btn.text}}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import storyblokLink from "@/mixins/storyblokLink";
export default {
  mixins: [storyblokLink],
  computed: {
    stores() {
      return this.$store.getters.stores;
    },
    settings() {
      return this.$store.getters.settings;
    },
  },
  methods: {
    getIcon(icon) {
      if (icon) {
        return icon.icon.replace("fa-", "");
      }
    },
  },
};
</script>

<style lang="scss">
.checkout-btn {
  display: flex;
  position: relative;
  &:hover {
    .submenu {
      display: block;
    }
  }
  a {
    display: block;
    text-decoration: none;
    color: #fff;
    background-color: $primary-D;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 15px 25px;
    letter-spacing: 2px;
    text-transform: uppercase;
    font-family: "Luckiest Guy", cursive;
    &:hover {
      background-color: $primary-D;
    }
    .icon {
      margin: 0 5px;
    }
    span {
      padding-left: 10px;
    }
  }
  .submenu {
    position: absolute;
    top: 100%;
    width: max-content;
    display: none;
    li {
      &.eg {
        a {
          background-color: $eg;
          &:hover {
            background-color: darken($eg, 10%);
          }
        }
      }
      &.alb {
        a {
          background-color: $alb;
          &:hover {
            background-color: darken($alb, 10%);
          }
        }
      }
      &.stefoy {
        a {
          background-color: $stefoy;
          &:hover {
            background-color: darken($stefoy, 10%);
          }
        }
      }
    }
  }
}
</style>
